import ContactForm from "../../components/contact-form";
import axios from "axios";
import cogoToast from "cogo-toast";

const ContactContainer = () => {
    const onSubmit = (data) => {
        axios
            .post(
                "https://soul-house-harmony.onrender.com/contact/contactus",
                data
            )
            .then((res) => {
                console.log(res);
                if (res.status === 200)
                    cogoToast.success("submitted successfully", {
                        position: "bottom-left",
                    });
            })
            .catch((err) => {
                console.log(err);
                cogoToast.info("Error submitting form", {
                    position: "bottom-left",
                });
            });
    };

    return (
        <div className="section contact-section bg-dark">
            <div
                className="contact-bg"
                style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL}/images/contact-bg.jpg)`,
                }}
            ></div>

            <div className="container">
                <div className="row justify-content-end">
                    <div className="col-lg-7">
                        <div className="contact-section-wrapper">
                            <div className="contact-info" data-aos="fade-up">
                                <span className="mail">
                                    <a href="mailto:someone@example.com">
                                        info@neoneg.com
                                    </a>
                                </span>
                                <span className="number">
                                    <a href="tel:+012345678900">
                                        (+012) 345 67 89 00
                                    </a>
                                </span>
                            </div>

                            <div
                                className="contact-form"
                                data-aos="fade-up"
                                data-aos-duration="600"
                            >
                                <ContactForm onSubmit={onSubmit} />
                            </div>

                            <div
                                className="contact-social"
                                data-aos="fade-up"
                                data-aos-duration="900"
                            >
                                <ul>
                                    <li>
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            className="dribbble"
                                            href="https://dribbble.com/"
                                        >
                                            Dribbble
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            className="behance"
                                            href="https://www.behance.net/"
                                        >
                                            Behance
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            rel="noopener noreferrer"
                                            target="_blank"
                                            className="twitter"
                                            href="https://twitter.com/"
                                        >
                                            Twitter
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactContainer;
